
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ETipoPreferencia, ETipoProducto } from 'src/app/models/enums.enum';
import { IPreferencia } from 'src/app/models/interfaces-apis/diccionarios';
import { ObservacionesComponent } from '../../../form-componentes/observaciones/observaciones.component';
import { IFichaCliente, IPreferenciaCliente } from 'src/app/models/interfaces-apis/ficha_cliente';
import { preferencias } from 'src/app/models/General/preferencias';
import { GrupoPreferenciaComponent } from 'src/app/componentes/form-componentes/grupo-preferencia/grupo-preferencia.component';
import { UserService } from 'src/app/servicios/user.service';

@Component({
  selector: 'app-preferencias-barco',
  templateUrl: './preferencias-barco.component.html',
  styleUrls: ['./preferencias-barco.component.scss']
})
export class PreferenciasBarcoComponent extends preferencias implements OnInit {

  @ViewChild('Grupo_Preferencia_Barco_Observaciones') Grupo_Preferencia_Barco_Observaciones: ObservacionesComponent;
  @ViewChildren('Grupo_Preferencia_Barco') grupos!: QueryList<GrupoPreferenciaComponent>;

  constructor(private _userService: UserService) {
    super();
  }

  ngOnInit(): void {
  }

  ETipoProducto = ETipoProducto;
  TipoPreferencia = ETipoPreferencia;

  @Input() preferencias: IPreferencia[];

  @Input() clienteFicha: IFichaCliente;

  @Input() listaOtros: string[];

  
  //Obtener la lista de las preferencias barco guardadas
  obtenerPreferenciasGuardadas(): IPreferenciaCliente[] {

    let ListaPreferencias: IPreferenciaCliente[] = []

    this.grupos.forEach((grupo) => {
      let resultado = grupo.obtenerPreferencias();
      let opcionesPreferencias: IPreferenciaCliente = {
        Tipo: grupo.Id,
        Preferencias: resultado[0],
        InfoEspecifica: resultado[1]
      };
      ListaPreferencias.push(opcionesPreferencias);
    });

    let textoObservacion = this.Grupo_Preferencia_Barco_Observaciones.obtenerPreferencias()
    let preferenciaBarcoObservaciones: IPreferenciaCliente = {
      Tipo: this._userService.getTipoPreferenciasId('ObservacionBarco'),
      Preferencias: null,
      InfoEspecifica: textoObservacion,
    }
    ListaPreferencias.push(preferenciaBarcoObservaciones)

    return ListaPreferencias;

  }

  //Actualziar preferencias barco
  actualizar() {
    let preferencias = this.clienteFicha.Preferencias

    let preferenciasTipoBarco = this.preferencias.filter(o => o.TipoProducto === ETipoProducto.Barco);
    let idsPreferencias = preferenciasTipoBarco.map(o => o.Id);
    let resultado = preferencias.filter(o => idsPreferencias.includes(o.Tipo));
    this.grupos.forEach((grupo) => {
      const preferencia = resultado.find(p => p.Tipo === grupo.Id);
      if (preferencia) {
        grupo.actualizar(preferencia.Preferencias, preferencia.InfoEspecifica);
      }
    });

    let preferenciaTextoObservacionBarco: IPreferenciaCliente = this.obtenerPreferenciasCliente(preferencias, this._userService.getTipoPreferenciasId('ObservacionBarco'))

    this.Grupo_Preferencia_Barco_Observaciones.actualizar(preferenciaTextoObservacionBarco?.InfoEspecifica);
  }

  //Validar preferencias Barco
  validarPreferencias() {
    let validacionPreferenciasBarco = this.grupos.toArray().every(grupo => grupo.validarPreferencias());
    return validacionPreferenciasBarco;
  }

}
